module.exports = __webpack_public_path__ + "img/search.16c460c3.svg";